"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A global view on the errors. Essentially a sink for the errors from the server
 */
var errorsCache_1 = require("../server/utils/errorsCache");
exports.errorsCache = new errorsCache_1.ErrorsCache();



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/globalErrorCacheClient.js
 ** module id = 35
 ** module chunks = 0
 **/